// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MxZ_","largestCol":"styles_largestCol__4bWbb","smallestCol":"styles_smallestCol__2sXuT"};